module.exports = __webpack_public_path__ + "assets/imgs/logos/applovin.b3cf1b4e9c21baa09d82d6fb0341ab18.png";